import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowRight } from "lucide-react";
import { PageHero, Reveal } from "../components/site/Motion";
import { http, DIVISIONS } from "../lib/api";
import { useSettings } from "../lib/settings";

export default function Divisions() {
  const s = useSettings();
  const { data } = useQuery({ queryKey: ["facets"], queryFn: async () => (await http.get("/assets/facets")).data, retry: 1 });
  return (
    <div data-testid="divisions-page">
      <PageHero eyebrow="Our Divisions" title={["Four divisions,", "one standard."]} intro="Selby Asset Group serves buyers across multiple industries. Each division can present listed inventory or search for assets on your behalf." testid="divisions-hero" />
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-20 space-y-24 md:space-y-32">
        {DIVISIONS.map((d, i) => {
          const n = data?.counts?.[d.key] ?? 0;
          return (
            <section key={d.key} className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center" data-testid={`division-section-${d.key}`}>
              <Reveal className={`lg:col-span-7 ${i % 2 ? "lg:order-2" : ""}`}>
                <Link to={`/divisions/${d.key}`} className="block clip-frame relative aspect-[16/11] overflow-hidden group">
                  <img src={d.img} alt={d.name} loading="lazy" className="w-full h-full object-cover transition-transform duration-[1.6s] group-hover:scale-105" />
                  <span className="absolute top-5 left-5 font-mono text-xs bg-[#0a0d14]/75 backdrop-blur px-3 py-1.5 border border-white/15">0{i + 1} / 04</span>
                </Link>
              </Reveal>
              <Reveal delay={0.1} className="lg:col-span-5">
                <p className="eyebrow">{n > 0 ? `${n} verified listing${n === 1 ? "" : "s"} · more available upon request` : "Available upon request"}</p>
                <h2 className="font-display text-5xl md:text-6xl mt-4 text-slate-50 leading-[1]">{d.name}</h2>
                <p className="text-slate-300 mt-5 leading-relaxed">{d.blurb}</p>
                <p className="text-sm text-slate-400 mt-3">Contact: <a href={`mailto:${s.sales_email}`} className="text-gold hover:underline">{s.sales_email}</a></p>
                <ul className="mt-7 flex flex-wrap gap-2">
                  {d.categories.map((c) => (
                    <li key={c}><Link to={`/divisions/${d.key}?category=${encodeURIComponent(c)}`} className="inline-block text-xs border border-white/15 px-3 py-2 text-slate-200 hover:border-[var(--gold)] hover:text-gold transition-colors">{c}</Link></li>
                  ))}
                </ul>
                <div className="mt-9 flex flex-wrap gap-3">
                  <Link to={`/divisions/${d.key}`} className="btn-gold" data-testid={`division-browse-${d.key}`}>Explore {d.name} <ArrowRight className="w-4 h-4" /></Link>
                  <Link to={`/sourcing?division=${d.key}`} className="btn-ghost" data-testid={`division-source-${d.key}`}>Request an Asset</Link>
                </div>
              </Reveal>
            </section>
          );
        })}
      </div>
    </div>
  );
}
